// store/slices/objectSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ObjectNode } from '../../types';

interface ObjectState {
  objects: ObjectNode[];
  currentObject: ObjectNode | null;
  breadcrumbs: ObjectNode[];
  loading: boolean;
  error: string | null;
}

const initialState: ObjectState = {
  objects: [],
  currentObject: null,
  breadcrumbs: [],
  loading: false,
  error: null,
};

const objectSlice = createSlice({
  name: 'objects',
  initialState,
  reducers: {
    setObjects: (state, action: PayloadAction<ObjectNode[]>) => {
      state.objects = action.payload;
    },
    setCurrentObject: (state, action: PayloadAction<ObjectNode>) => {
      state.currentObject = action.payload;
    },
    setBreadcrumbs: (state, action: PayloadAction<ObjectNode[]>) => {
      state.breadcrumbs = action.payload;
    },
  },
});

export const { setObjects, setCurrentObject, setBreadcrumbs } = objectSlice.actions;
export default objectSlice.reducer;